import { render } from "./TaskCustomFieldListPage.vue?vue&type=template&id=7edb5e87&ts=true"
import script from "./TaskCustomFieldListPage.vue?vue&type=script&lang=ts"
export * from "./TaskCustomFieldListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__